import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { sortedTiers, tierIcon, tierColor } from "./UserTier";

const getTier = (count) => {
  for (const [tier, threshold] of sortedTiers) {
    if (count >= threshold) return tier;
  }
  return "Iron";
};

const AllUserTiers = ({ db, refreshTrigger }) => {
  const [tierData, setTierData] = useState(null);

  useEffect(() => {
    const fetchTier = async () => {
      const voteCountsRef = collection(db, "voteCounts");
      const snapshot = await getDocs(voteCountsRef);

      if (snapshot.empty) return "No users found.";

      const tierCounts = {};

      snapshot.forEach((doc) => {
        const count = doc.data().count || 0;
        const tier = getTier(count);
        tierCounts[tier] = (tierCounts[tier] || 0) + 1;
      });

      // Create an array of tier names in order from lowest to highest
      // We need to reverse the sortedTiers array because it's currently sorted from highest to lowest
      const orderedTiers = sortedTiers.map(([tier]) => tier).reverse();

      // Calculate cumulative counts (users at that tier and above)
      const cumulativeCounts = {};
      let runningTotal = 0;

      // Process tiers from highest to lowest to calculate cumulative counts
      for (let i = orderedTiers.length - 1; i >= 0; i--) {
        const tier = orderedTiers[i];
        runningTotal += tierCounts[tier] || 0;
        cumulativeCounts[tier] = runningTotal;
      }

      // Filter to only include tiers that have users
      const tiersWithUsers = orderedTiers.filter((tier) => tierCounts[tier]);

      const return_val = tiersWithUsers.map((tier) => (
        <span
          key={tier}
          style={{
            marginRight: "10px",
            display: "inline-flex",
            alignItems: "center",
            color: `${tierColor[tier]}`,
          }}
        >
          &nbsp;{cumulativeCounts[tier]}
          {tierIcon[tier]}
        </span>
      ));
      setTierData(return_val);
    };
    fetchTier();
  }, [db, refreshTrigger]);

  return <div>Users: {tierData}</div>;
};

export default AllUserTiers;
